import { render, staticRenderFns } from "./CmgOrderConfirmation.vue?vue&type=template&id=0cc1e0d0&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmation.vue?vue&type=style&index=0&id=0cc1e0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1e0d0",
  null
  
)

export default component.exports